export default {
  Product: '/blugento',
  ProductHosting: '/hosting',
  ProductFeatures: '/functionalitati',
  ProductFeaturesLocalization: '/localizare',
  ProductFeaturesCatalog: '/functionalitati-catalog-atribute-categorii',
  ProductFeaturesClientsOrders: '/functionalitati-clienti-comenzi',
  ProductFeaturesMarketing: '/functionalitati-marketing',
  ProductFeaturesSeo: '/functionalitati-seo',
  ProductERP: '/facturare-erp-wms',
  ProductPaymentsShipping: '/plata-curierat',
  ProductMarketplace: '/marketplace',
  ProductIntegrations: '/integrari',
  Design: '/design',
  DesignTemplates: '/express',
  Support: '/suport',
  DeliveryProcess: '/proces-delivery',
  B2B: '/b2b',
  Pricing: '/preturi',
  PricingCompare: '/compara-pachete',
  CustomerSuccess: '/customer-success',
  Zea: '/marketing',
  Zento: '/zento',
  Careers: '/careers',
  Contact: '/contact',
  SLA: '/ce-este-inclus-in-pachetul-de-abonament-blugento',
  Blog: '/blog',
  BlogArticle: '/blog/article',
  PrivacyPolicy: '/politica-de-confidentialitate',
  CookiePolicy: '/politica-de-utilizare-cookie-uri',
  GetBlugento: '/discuta-cu-noi',
  Events: '/evenimente',
  EventsEvent: '/evenimente/eveniment',
  Partners: '/parteneri',
  PartnersPartner: '/parteneri/partener',
  LPList: '/campanii',
  LPCampaign1: '/platforma-comert-online',
};
